"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Env = require("./Env");

var _default = {
  API_DOMAIN: "api.hubspot" + _Env.domainSuffix + ".com"
};
exports.default = _default;
module.exports = exports.default;